import React from "react";

// Logos
import AllureLogo from "./images/logos/allure.png";
import AnnunciFunebriLogo from "./images/logos/annuncifunebri.png";
import ArubaFatturaElettronicaLogo from "./images/logos/aruba_fattura_elettronica.png";
import ArubaPartnerLogo from "./images/logos/aruba_partner.png";
import Auth0Logo from "./images/logos/auth0.png";
import AwsLogo from "./images/logos/aws.png";
import BlSrlLogo from "./images/logos/blsrl.png";
import Bugsink from "./images/logos/bugsink.png";
import CanvaLogo from "./images/logos/canva.png";
import CardsLogo from "./images/logos/cards.png";
import CloudflareLogo from "./images/logos/cloudflare.webp";
import ConfluenceLogo from "./images/logos/confluence.png";
import DataStudioLogo from "./images/logos/datastudio.png";
import DockerHubLogo from "./images/logos/dockerhub.png";
import DocuSealLogo from "./images/logos/docuseal.png";
import ElasticLogo from "./images/logos/elasticsearch.svg";
import EnvatoLogo from "./images/logos/envato.jpg";
import FacebookLogo from "./images/logos/facebook.png";
import FalLogo from "./images/logos/fal_ai.png";
import FlatIconLogo from "./images/logos/flaticon.png";
import TimetasticLogo from "./images/logos/timetastic.png";
import GitHubLogo from "./images/logos/github.png";
import GoogleAdwordsLogo from "./images/logos/google_adwords.png";
import GoogleAnalyticsLogo from "./images/logos/google_analytics.png";
import GoogleDocsLogo from "./images/logos/google_docs.png";
import GooglePostmastersLogo from "./images/logos/google_postmasters.png";
import GoogleSearchConsoleLogo from "./images/logos/google_search_console.jpg";
import GoogleTagManagerLogo from "./images/logos/google_tag_manager.png";
import GoogleTrendsLogo from "./images/logos/google_trends.png";
import GrafanaLogo from "./images/logos/grafana.jpg";
import GraphQlLogo from "./images/logos/graphql.png";
import GSuiteLogo from "./images/logos/g_suite.png";
import InstagramLogo from "./images/logos/instagram.jpg";
import IubendaLogo from "./images/logos/iubenda.png";
import JiraLogo from "./images/logos/jira.png";
import LabelStudioLogo from "./images/logos/label_studio.png";
import LinearLogo from "./images/logos/linear.png";
import LinkedInLogo from "./images/logos/linkedin.png";
import LyberLogo from "./images/logos/lyber.jpg";
import MailTesterLogo from "./images/logos/mail_tester.png";
import MixPanel from "./images/logos/mixpanel.png";
import MongoDbAtlasLogo from "./images/logos/mongodb.png";
import NotionLogo from "./images/logos/notion.png";
import NpmLogo from "./images/logos/npm.svg";
import OfcSupportLogo from "./images/logos/ofc_support.png";
import OneSignalLogo from "./images/logos/onesignal.png";
import OpenAILogo from "./images/logos/openai.png";
import OpenCollectiveLogo from "./images/logos/open_collective.png";
import OpsGenieLogo from "./images/logos/opsgenie.png";
import ParseLogo from "./images/logos/parse.png";
import PatreonLogo from "./images/logos/patreon.png";
import PhpLogo from "./images/logos/php.png";
import PixianAiLogo from "./images/logos/pixian.png";
import RapidAPILogo from "./images/logos/rapid.png";
import ReplicateLogo from "./images/logos/replicate.png";
import HeroiconsLogo from "./images/logos/heroicons.png";
import StripeLogo from "./images/logos/stripe.png";
import TailwindLogo from "./images/logos/tailwind.svg";
import UnsplashLogo from "./images/logos/unsplash.png";
import VastLogo from "./images/logos/vast.png";
import WebflowLogo from "./images/logos/webflow.png";
import YouTubeLogo from "./images/logos/youtube.png";
import ZohoCrmLogo from "./images/logos/zoho_crm.png";
import ZohoAnalytics from "./images/logos/zoho_analytics.png";
import IntercomLogo from "./images/logos/intercom.png";
import HetznerLogo from "./images/logos/hetzner.svg";
import N8nLogo from "./images/logos/n8n.png";
import ClaudeLogo from "./images/logos/claude.png";
import MetaLogo from "./images/logos/meta.png";
import OpenReplayLogo from "./images/logos/open_replay.png";
import EmailEngineLogo from "./images/logos/emailengine_logo.png";
import PagerDutyLogo from "./images/logos/pagerduty.png";
import OpenPanelLogo from "./images/logos/open_panel_dev.png";
import StorybookLogo from "./images/logos/storybook.png";

// Menu icons
import {
  ApartmentOutlined,
  AppstoreOutlined,
  DashboardOutlined,
  BuildOutlined,
  CodeOutlined,
  DollarCircleOutlined,
  GoogleOutlined,
  IeOutlined,
  LineChartOutlined,
  SettingOutlined,
  TeamOutlined,
  ToolOutlined,
  FileTextOutlined,
  PlayCircleOutlined,
  DatabaseOutlined,
  ExportOutlined,
  SaveOutlined,
  ImportOutlined,
  ShopOutlined,
  UserOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";

const OfcLogo = "https://cdn.onoranzefunebricloud.com/logos/ofc_blu.png";
const GiottoLogo = "https://cdn.onoranzefunebricloud.com/logos/giotto_blu.png";
const EternoLogo = "https://cdn.onoranzefunebricloud.com/logos/eterno_blu.png";

export const appsConfig = [
  /**
   * Left Column
   */
  {
    title: "Data & Cloud Providers",
    displayOnSide: "left",
    apps: [
      {
        name: "Parse Dashboard",
        url: "http://parse-dashboard.dev-onoranzefunebricloud.com/",
        logo: ParseLogo,
        env: "dev",
      },
      {
        name: "Parse Dashboard",
        url: "http://parse-dashboard.onoranzefunebricloud.com/",
        logo: ParseLogo,
        env: "prod",
      },
      {
        name: "AWS Dev",
        url: "https://482321971896.signin.aws.amazon.com/console",
        logo: AwsLogo,
        env: "dev",
      },
      {
        name: "AWS Prod",
        url: "https://118905968587.signin.aws.amazon.com/console",
        logo: AwsLogo,
        env: "prod",
      },
      {
        name: "AWS Backup",
        url: "https://730335481505.signin.aws.amazon.com/console",
        logo: AwsLogo,
        env: "prod",
      },
      {
        name: "MongoDB Atlas",
        url: "https://cloud.mongodb.com/",
        logo: MongoDbAtlasLogo,
      },
      {
        name: "Elasticsearch",
        url: "https://011ea75f19904d5a8dd348ce4c44253c.us-east-1.aws.found.io:9243/login?next=%2F",
        logo: ElasticLogo,
      },
      {
        name: "DockerHub",
        url: "https://hub.docker.com/u/onoranzefunebricloud",
        logo: DockerHubLogo,
      },
      {
        name: "Hetzner",
        url: "https://console.hetzner.cloud/",
        logo: HetznerLogo,
      },
      {
        name: "Cloudflare",
        url: "https://dash.cloudflare.com",
        logo: CloudflareLogo,
      },
    ],
  },
  {
    title: "AI",
    displayOnSide: "left",
    apps: [
      {
        name: "OFC AI Providers",
        url: "https://docs.google.com/document/d/145jfPXI-o_kErP5Eg792n7U6EsgUGCLFs69-iqyfYKo",
        logo: GoogleDocsLogo,
      },
      {
        name: "Pixian.ai",
        url: "https://pixian.ai/dashboard",
        logo: PixianAiLogo,
      },
      {
        name: "RapidAPI",
        url: "https://rapidapi.com/developer/dashboard",
        logo: RapidAPILogo,
      },
      {
        name: "Vast.ai",
        url: "https://cloud.vast.ai/instances/",
        logo: VastLogo,
      },
      {
        name: "OpenAI",
        url: "https://platform.openai.com",
        logo: OpenAILogo,
      },
      {
        name: "Claude",
        url: "https://console.anthropic.com",
        logo: ClaudeLogo,
      },
      {
        name: "Fal",
        url: "https://fal.ai/dashboard",
        logo: FalLogo,
      },
      {
        name: "Replicate",
        url: "https://replicate.com/",
        logo: ReplicateLogo,
      },
      {
        name: "Label Studio",
        url: "https://label-studio.onoranzefunebricloud.com",
        logo: LabelStudioLogo,
      },
    ],
  },
  {
    title: "Monitoring",
    displayOnSide: "left",
    apps: [
      {
        name: "Bugsink",
        url: "https://bugsink.onoranzefunebricloud.com/",
        logo: Bugsink,
        env: "prod",
      },
      {
        name: "Grafana",
        url: "https://grafana.dev-onoranzefunebricloud.com/",
        logo: GrafanaLogo,
        env: "dev",
      },
      {
        name: "Grafana",
        url: "https://grafana.onoranzefunebricloud.com/",
        logo: GrafanaLogo,
        env: "prod",
      },
      {
        name: "OpsGenie",
        url: "https://onoranzefunebricloud.app.eu.opsgenie.com/",
        logo: OpsGenieLogo,
      },
      {
        name: "PagerDuty",
        url: "https://onoranzefunebricloud.eu.pagerduty.com",
        logo: PagerDutyLogo,
        env: "prod",
      },
      {
        name: "OpenPanel",
        url: "http://op.onoranzefunebricloud.com",
        logo: OpenPanelLogo,
        env: "prod",
      },
    ],
  },
  {
    title: "Development",
    displayOnSide: "left",
    apps: [
      {
        name: "GitHub",
        url: "https://github.com/onoranzefunebricloud",
        logo: GitHubLogo,
      },
      {
        name: "OFC NPM Registry",
        url: "https://www.npmjs.com/settings/onoranzefunebricloud/packages",
        logo: NpmLogo,
      },
      {
        name: "Allure (dev)",
        url: "https://test-reports.dev-onoranzefunebricloud.com",
        logo: AllureLogo,
        env: "dev",
      },
      {
        name: "Allure (prod)",
        url: "https://test-reports.onoranzefunebricloud.com",
        logo: AllureLogo,
        env: "prod",
      },
      {
        name: "OneSignal (dev)",
        url: "https://app.onesignal.com/apps/f064c61a-609d-409c-88f2-cac4a80a88e9",
        logo: OneSignalLogo,
        env: "dev",
      },
      {
        name: "OneSignal (prod)",
        url: "https://app.onesignal.com/apps/51b8f54e-4b35-4856-a401-9aac18e791b7",
        logo: OneSignalLogo,
        env: "prod",
      },
      {
        name: "n8n",
        url: "https://n8n.onoranzefunebricloud.com/",
        logo: N8nLogo,
      },
      {
        name: "EmailEngine",
        url: "https://emailengine.dev-onoranzefunebricloud.com",
        logo: EmailEngineLogo,
        env: "dev",
      },
      {
        name: "EmailEngine",
        url: "https://emailengine.onoranzefunebricloud.com",
        logo: EmailEngineLogo,
        env: "prod",
      },
      {
        name: "Storybook",
        url: "https://d2ydhdp3lcwih8.cloudfront.net/00dab092-ff17-4083-9391-3664fbcb9066",
        logo: StorybookLogo,
      },
    ],
  },
  {
    title: "Software Docs",
    displayOnSide: "left",
    apps: [
      {
        name: "Tailwind CSS",
        url: "https://tailwindcss.com/docs",
        logo: TailwindLogo,
      },
      {
        name: "Parse Server JS SDK",
        url: "https://docs.parseplatform.org/js/guide/",
        logo: ParseLogo,
      },
      {
        name: "Parse Server GraphQL",
        url: "https://docs.parseplatform.org/graphql/guide/",
        logo: GraphQlLogo,
      },
      {
        name: "Parse Server PHP SDK",
        url: "https://docs.parseplatform.org/php/guide/",
        logo: PhpLogo,
      },
      {
        name: "Parse Env Vars Config",
        url: "https://github.com/parse-community/parse-server/blob/alpha/src/Options/Definitions.js",
        logo: GitHubLogo,
      },
    ],
  },
  {
    title: "Open Source",
    displayOnSide: "left",
    apps: [
      {
        name: "Parse Open Collective",
        url: "https://opencollective.com/parse-server",
        logo: OpenCollectiveLogo,
      },
      {
        name: "Parse Community",
        url: "https://community.parseplatform.org/",
        logo: ParseLogo,
      },
      {
        name: "FabricJS Patreon",
        url: "https://www.patreon.com/fabricJS/posts",
        logo: PatreonLogo,
      },
      {
        name: "FabricJS",
        url: "https://github.com/fabricjs/fabric.js",
        logo: GitHubLogo,
      },
      {
        name: "Parse Server",
        url: "https://github.com/parse-community/parse-server",
        logo: GitHubLogo,
      },
      {
        name: "Parse Dashboard",
        url: "https://github.com/parse-community/parse-dashboard",
        logo: GitHubLogo,
      },
      {
        name: "Parse Platform",
        url: "https://hub.docker.com/u/parseplatform",
        logo: DockerHubLogo,
      },
    ],
  },

  /**
   * Right Column
   */
  {
    title: "Gestione",
    displayOnSide: "right",
    apps: [
      {
        name: "Dev Board",
        url: "https://onoranzefunebricloud.atlassian.net/jira/software/c/projects/DV/boards/4",
        logo: JiraLogo,
      },
      {
        name: "Linear",
        url: "https://linear.app",
        logo: LinearLogo,
      },
      {
        name: "Confluence",
        url: "https://onoranzefunebricloud.atlassian.net/wiki/home",
        logo: ConfluenceLogo,
      },
      {
        name: "Timetastic",
        url: "https://app.timetastic.co.uk/wallchart",
        logo: TimetasticLogo,
      },
      {
        name: "Google Suite",
        url: "https://gsuite.google.com/dashboard",
        logo: GSuiteLogo,
      },
      {
        name: "Notion",
        url: "https://www.notion.so/onoranzefunebricloud",
        logo: NotionLogo,
      },
    ],
  },
  {
    title: "Customers & Subscriptions",
    displayOnSide: "right",
    apps: [
      {
        name: "Leads",
        url: "https://crm.zoho.eu/crm/org20108764695/tab/Leads/custom-view/886942000000030939/list",
        logo: ZohoCrmLogo,
      },
      {
        name: "Contatti",
        url: "https://crm.zoho.eu/crm/org20108764695/tab/Contacts/custom-view/886942000000030971/list",
        logo: ZohoCrmLogo,
      },
      {
        name: "Aziende",
        url: "https://crm.zoho.eu/crm/org20108764695/tab/Accounts/custom-view/886942000000030957/list",
        logo: ZohoCrmLogo,
      },
      {
        name: "Trattative",
        url: "https://crm.zoho.eu/crm/org20108764695/tab/Potentials/custom-view/886942000000030987/list",
        logo: ZohoCrmLogo,
      },
      {
        name: "Attività",
        url: "https://crm.zoho.eu/crm/org20108764695/tab/Tasks/custom-view/886942000000269292/kanban?kvId=886942000000526639",
        logo: ZohoCrmLogo,
      },
      {
        name: "Stripe",
        url: "https://dashboard.stripe.com/login",
        logo: StripeLogo,
      },
      {
        name: "Guide",
        url: "https://wiki.onoranzefunebricloud.com",
        logo: OfcSupportLogo,
      },
      {
        name: "Intercom",
        url: "https://app.intercom.com/",
        logo: IntercomLogo,
      },
      {
        name: "Auth0",
        url: "https://manage.auth0.com/dashboard/eu/ofc-dev/",
        logo: Auth0Logo,
        env: "dev",
      },
      {
        name: "Auth0",
        url: "https://manage.auth0.com/dashboard/eu/ofc/",
        logo: Auth0Logo,
        env: "prod",
      },
      {
        name: "OpenReplay",
        url: "https://opr.onoranzefunebricloud.com",
        logo: OpenReplayLogo,
        env: "prod",
      },
    ],
  },
  {
    title: "Prodotti e risorse clienti",
    displayOnSide: "extra",
    apps: [
      {
        name: "News Changelog Pubblico",
        url: "https://news.onoranzefunebricloud.com/it/news",
        logo: OfcLogo,
        env: "prod",
      },
      {
        name: "Guide e Articoli Supporto",
        url: "http://supporto.onoranzefunebricloud.com/",
        logo: OfcLogo,
        env: "prod",
      },
      {
        name: "Eterno",
        url: "https://eterno.dev-onoranzefunebricloud.com",
        logo: EternoLogo,
        env: "dev",
      },
      {
        name: "Eterno",
        url: "https://eterno.onoranzefunebricloud.com",
        logo: EternoLogo,
        env: "prod",
      },
      {
        name: "Giotto",
        url: "https://editor.giotto.dev-onoranzefunebricloud.com",
        logo: GiottoLogo,
        env: "dev",
      },
      {
        name: "Giotto",
        url: "https://editor.giotto.onoranzefunebricloud.com",
        logo: GiottoLogo,
        env: "prod",
      },
      {
        name: "FuneralCloud",
        url: "https://funeralcloud.dev-onoranzefunebricloud.com",
        logo: EternoLogo,
        env: "dev",
      },
      {
        name: "FuneralCloud",
        url: "https://funeralcloud.it",
        logo: EternoLogo,
        env: "prod",
      },
      {
        name: "Cards Dashboard",
        url: "https://cards-admin.dev-onoranzefunebricloud.com",
        logo: CardsLogo,
        env: "dev",
      },
      {
        name: "Cards Dashboard",
        url: "https://cards-admin.onoranzefunebricloud.com",
        logo: CardsLogo,
        env: "prod",
      },
      {
        name: "Whatsapp Meta",
        url: "https://business.facebook.com/latest/whatsapp_manager/message_templates?business_id=380066085791872&tab=message-templates&nav_ref=whatsapp_manager&asset_id=1210112954373566",
        logo: MetaLogo,
        env: "prod",
      },
    ],
  },
  {
    title: "Landing Pages",
    displayOnSide: "extra",
    apps: [
      {
        name: "Sito",
        url: "https://onoranzefunebricloud.com",
        logo: OfcLogo,
      },
      {
        name: "Eterno Segnalatore",
        url: "https://eterno.onoranzefunebricloud.com/public/landing/sales.php",
        logo: EternoLogo,
      },
    ],
  },
  {
    title: "Analytics & ADV",
    displayOnSide: "extra",
    apps: [
      {
        name: "MixPanel Dev",
        url: "https://eu.mixpanel.com/project/3436017/view/3939521/app/boards",
        env: "dev",
        logo: MixPanel,
      },
      {
        name: "MixPanel Prod",
        url: "https://eu.mixpanel.com/project/3436013/view/3939513/app/home",
        env: "prod",
        logo: MixPanel,
      },
      {
        name: "Zoho Analytics",
        url: "https://analytics.zoho.eu/ZDBHome.cc?home=true",
        logo: ZohoAnalytics,
      },
      {
        name: "FB Business Manager",
        url: "https://business.facebook.com/adsmanager/manage/campaigns?act=380068022458345&business_id=380066085791872&global_scope_id=380066085791872&tool=MANAGE_ADS&nav_source=flyout_menu&nav_id=2891320074&date=2020-11-14_2020-11-15%2Ctoday",
        logo: FacebookLogo,
      },
      {
        name: "FB Business Suite",
        url: "https://business.facebook.com/latest/home?asset_id=1892657624281638&business_id=380066085791872&nav_ref=bm_home_redirect",
        logo: FacebookLogo,
      },
      {
        name: "G Search Console",
        url: "https://search.google.com/search-console?hl=it&resource_id=sc-domain:onoranzefunebricloud.com",
        logo: GoogleSearchConsoleLogo,
      },
      {
        name: "Google Analytics",
        url: "https://analytics.google.com/analytics/web/#/",
        logo: GoogleAnalyticsLogo,
      },
      {
        name: "Google Data Studio",
        url: "https://datastudio.google.com/u/0/reporting/2da07086-b67e-4a70-be84-eca93e43423d/page/4VDGB",
        logo: DataStudioLogo,
      },
      {
        name: "Google Tag Manager",
        url: "https://tagmanager.google.com/#/container/accounts/6001672973/containers/31994141/workspaces/4/tags",
        logo: GoogleTagManagerLogo,
      },
      {
        name: "Google Adwords",
        url: "https://ads.google.com/aw/overview?ocid=285738418&euid=303155474&__u=2186567426&uscid=285738418&__c=6725406882&authuser=0&subid=ALL-it-et-g-aw-c-home-awhp_xin1_signin!o2",
        logo: GoogleAdwordsLogo,
      },
      {
        name: "Google Trends",
        url: "https://trends.google.it/trends/?geo=IT",
        logo: GoogleTrendsLogo,
      },
      {
        name: "Google Postmasters",
        url: "https://postmaster.google.com/",
        logo: GooglePostmastersLogo,
      },
      {
        name: "Campaign Manager",
        url: "https://www.linkedin.com/campaignmanager/accounts/506849069/campaign-groups",
        logo: LinkedInLogo,
      },
    ],
  },
  {
    title: "Socials",
    displayOnSide: "extra",
    apps: [
      {
        name: "Facebook",
        url: "https://www.facebook.com/onoranzefunebricloud/",
        logo: FacebookLogo,
      },
      {
        name: "Instagram",
        url: "https://www.instagram.com/onoranzefunebricloud/",
        logo: InstagramLogo,
      },
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/company/onoranzefunebricloud/",
        logo: LinkedInLogo,
      },
      {
        name: "YouTube",
        url: "https://www.youtube.com/channel/UCAft4XAHnb_DIavWF8s2pbw",
        logo: YouTubeLogo,
      },
    ],
  },
  {
    title: "Partners",
    displayOnSide: "extra",
    apps: [
      {
        name: "Annunci Funebri",
        url: "https://www.annuncifunebri.it/",
        logo: AnnunciFunebriLogo,
      },
      {
        name: "BL",
        url: "https://www.blsrl.net/",
        logo: BlSrlLogo,
      },
    ],
  },
  {
    title: "Tools",
    displayOnSide: "extra",
    apps: [
      {
        name: "Mail Tester",
        url: "https://www.mail-tester.com/",
        logo: MailTesterLogo,
      },
      {
        name: "AI Edit Comparator",
        url: "https://n8n.onoranzefunebricloud.com/form/af90470e-e888-4717-ac8a-51cb10616ffe",
        logo: N8nLogo,
      },
    ],
  },
  {
    title: "Content & Design",
    displayOnSide: "right",
    apps: [
      {
        name: "Webflow",
        url: "https://webflow.com/dashboard?workspace=ofc-srl",
        logo: WebflowLogo,
      },
      {
        name: "Unsplash",
        url: "https://unsplash.com/",
        logo: UnsplashLogo,
      },
      {
        name: "Canva",
        url: "https://www.canva.com/",
        logo: CanvaLogo,
      },
      {
        name: "Envato",
        url: "https://elements.envato.com/",
        logo: EnvatoLogo,
      },
      {
        name: "Heroicons",
        url: "https://heroicons.com/",
        logo: HeroiconsLogo,
      },
      {
        name: "Flat Icon",
        url: "https://www.flaticon.com/",
        logo: FlatIconLogo,
      },
      {
        name: "Tailwind UI",
        url: "https://tailwindui.com/",
        logo: TailwindLogo,
      },
    ],
  },
  {
    title: "Services",
    displayOnSide: "right",
    apps: [
      {
        name: "Iubenda",
        url: "https://www.iubenda.com/it/dashboard",
        logo: IubendaLogo,
      },
      {
        name: "Lyber",
        url: "https://my.lyber.it/dashboard",
        logo: LyberLogo,
      },
      {
        name: "Aruba Partner",
        url: "https://partner.arubapec.it/arubapec/login",
        logo: ArubaPartnerLogo,
      },
      {
        name: "Fattura Elettronica",
        url: "https://fatturazioneelettronica.aruba.it/#login",
        logo: ArubaFatturaElettronicaLogo,
      },
      {
        name: "DocuSeal",
        url: "https://docuseal.eu/",
        logo: DocuSealLogo,
      },
    ],
  },
];

export const sidebarItems = [
  {
    title: "Dashboard",
    url: "/",
    icon: <DashboardOutlined />,
    allowAccessToNonOfcStaff: true,
  },
  {
    title: "App Launcher",
    url: "/apps",
    icon: <AppstoreOutlined />,
    allowAccessToNonOfcStaff: true,
  },
  {
    title: "Organizzazioni",
    url: "/orgs",
    icon: <TeamOutlined />,
    allowAccessToNonOfcStaff: true,
  },
  {
    title: "Utenti",
    url: "/users",
    icon: <UserOutlined />,
    allowAccessToNonOfcStaff: true,
  },
  {
    title: "Eterno",
    icon: <IeOutlined />,
    items: [
      {
        title: "Documenti",
        url: "/documents",
      },
      {
        title: "Doc Scanner",
        url: "/doc-scanner",
      },
    ],
  },
  {
    title: "Giotto",
    icon: <GoogleOutlined />,
    items: [
      {
        title: "Giotto AI",
        url: "/giotto/ai",
      },
      {
        title: "Progetti dei Clienti",
        url: "/giotto/client-projects",
      },
      {
        title: "Annunci Funebri",
        url: "/giotto/annunci-funebri",
      },
    ],
  },
  {
    title: "FuneralCloud",
    icon: <ShopOutlined />,
    items: [
      {
        title: "Venditori",
        url: "/funeralcloud/sellers",
      },
      {
        title: "Organizzazioni",
        url: "/funeralcloud/orgs",
      },
      {
        title: "Categorie",
        url: "/funeralcloud/categories",
      },
      {
        title: "Tipologie",
        url: "/funeralcloud/typologies",
      },
      {
        title: "Features",
        url: "/funeralcloud/features",
      },
    ],
  },
  {
    title: "Pagamenti",
    icon: <DollarCircleOutlined />,
    items: [
      // {
      //   title: "Nuovo Pagamento",
      //   url: "/sales/create-payment-page",
      // },
      // {
      //   title: "Preventivatore",
      //   url: "/sales/create-quote",
      // },
    ],
  },
  {
    title: "Data & Analytics",
    icon: <LineChartOutlined />,
    items: [
      {
        title: "Crea contatto",
        url: "/sales/create-contact",
      },
      {
        title: "Abbonamenti",
        url: "/analytics/abbonamenti",
      },
      {
        title: "Storage",
        url: "/analytics/storage",
      },
      {
        title: "Mappe",
        items: [
          {
            title: "Mappa Agenzie",
            url: "/mappa",
          },
          {
            title: "Mappa Clienti",
            url: "/mappa-clienti",
          },
          {
            title: "Mappa Preventivi",
            url: "/mappa-preventivi",
          },
        ],
      },
      {
        title: "Dashboard",
        items: [
          {
            title: "Analisi Overview - Parse DB",
            url: "/analytics/usage",
          },
          {
            title: "MixPanel Public Monitor Dashboard",
            url: "https://eu.mixpanel.com/p/JhrrSZovc4FgQhDUtQwdeu",
          },
        ],
      },
      {
        title: "Dati Imprese",
        url: "/company-reports",
      },
      {
        title: "BI",
        items: [
          {
            title: "Moduli",
            url: "/admin/bi/module-revenue",
          },
        ],
      },
    ],
  },
  {
    title: "Strumenti",
    icon: <ToolOutlined />,
    allowAccessToNonOfcStaff: true,
    items: [
      {
        title: "Guide",
        url: "/settings/guides",
        allowAccessToNonOfcStaff: false,
      },
      {
        title: "Allegati",
        url: "/allegati",
        allowAccessToNonOfcStaff: false,
      },
      {
        title: "CDN",
        url: "/cdn-browser",
        allowAccessToNonOfcStaff: false,
      },
      {
        title: "Internal Drive",
        url: "/internal-drive",
        icon: <FolderOpenOutlined />,
        allowAccessToNonOfcStaff: true,
      },
      {
        title: "Timeline Eventi",
        url: "/system-events",
        allowAccessToNonOfcStaff: false,
      },
      // {
      //   title: "Broadcast Notifiche",
      //   url: "/send-notifications",
      // },
    ],
  },
  {
    title: "Developers",
    icon: <CodeOutlined />,
    items: [
      {
        title: "Builds",
        url: "/ci",
        icon: <BuildOutlined />,
      },
      {
        title: "Servizi",
        icon: <ApartmentOutlined />,
        url: "/servizi",
      },
      {
        title: "Test Reports",
        url: "/test-reports",
        icon: <FileTextOutlined />,
      },
      {
        title: "Image Service Playground",
        url: "/tools/image-service-playground",
        icon: <PlayCircleOutlined />,
      },
      {
        title: "Database (Danger Zone)",
        icon: <DatabaseOutlined />,
        items: [
          {
            title: "Esporta Tabelle DB in JSON",
            url: "/db/backup/download",
            icon: <ExportOutlined />,
          },
          {
            title: "Crea Backup",
            url: "/db/backup/new",
            icon: <SaveOutlined />,
          },
          {
            title: "Ripristina Backup",
            url: "/db/backup/restore",
            icon: <ImportOutlined />,
          },
        ],
      },
    ],
  },
  {
    title: "Configurazioni",
    icon: <SettingOutlined />,
    items: [
      {
        title: "Giotto",
        items: [
          {
            title: "Immagini",
            url: "/giotto/editor_images_default",
          },
          {
            title: "Sfondi",
            url: "/giotto/editor_backgrounds_default",
          },
          {
            title: "Simboli",
            url: "/giotto/editor_symbols_default",
          },
          {
            title: "Tags",
            url: "/giotto/tags",
          },
          {
            title: "Prodotti",
            url: "/giotto/prodotti",
          },
        ],
      },
      {
        title: "Features",
        url: "/settings/features",
      },
      {
        title: "Moduli",
        url: "/settings/modules",
      },
      {
        title: "Icone",
        url: "/settings/icons",
      },
      {
        title: "Termini e Condizioni",
        url: "/tos",
      },
    ],
  },
];

export const orgFilters = [
  {
    title: "Clienti Attivi",
    filterName: "activeCustomers",
  },
  {
    title: "Nuovi Clienti (45d)",
    filterName: "recentCustomers",
  },
  {
    title: "Eterno Scadenze Imminenti",
    filterName: "eternoExpireSoon",
  },
  {
    title: "Eterno Scadute Recenti",
    filterName: "eternoExpiredRecently",
  },
  {
    title: "Giotto Scadenze Imminenti",
    filterName: "giottoExpireSoon",
  },
  {
    title: "Giotto Scadute Recenti",
    filterName: "giottoExpiredRecently",
  },
  {
    title: "Fatturazione Elettronica Attiva",
    filterName: "fatturazioneElettronicaAttiva",
  },
  {
    title: "Annunci Funebri Attivi",
    filterName: "annunciFunebriAttivi",
  },
];

export const competitors = [
  {
    name: "Memento (Tosco Data SRL)",
    address: "Via Borgognoni 2/i - 51100 - Pistoia (PT)",
    lat: 43.932908,
    lng: 10.898325,
  },
  {
    name: "Pleos (LGM Software SRL)",
    address: "V.le Toscana, 53, 06016 San Giustino PG",
    lat: 43.553444,
    lng: 12.169289,
  },
  {
    name: "FBE (Xp Informatica s.r.l.)",
    address: "Via G. Fanelli, 14 - 74015 Martina Franca (TA)",
    lat: 40.702486,
    lng: 17.334957,
  },
  {
    name: "Aurora365 (EvLogica Srls)",
    address: "Via Marittima, 196 – 03100 Frosinone (FR), IT",
    lat: 41.636639,
    lng: 13.340472,
  },
  {
    name: "AldilApp (STUP1 srl)",
    address: "Via Montenapoleone n.8, 20121 Milano (IT)",
    lat: 45.473972,
    lng: 9.168356,
  },
  {
    name: "Envigest (ENVI S.N.C. DI VARENNA VINCENZO, GIOIA VIRGINIO & C)",
    address: "Via Catalani 85 – 20833 Giussano (MB) – IT",
    lat: 45.679028,
    lng: 9.20572,
  },
];

export const partners = [
  {
    name: "Annunci Funebri (Cas Per SRL)",
    address: "Via Pontebbana 52, 33017 Tarcento (UD)",
    lat: 46.204425,
    lng: 13.189888,
  },
  {
    name: "BL S.r.l.",
    address: "via P. Togliatti, 1 - 21010 Cardano al Campo (VA)",
    lat: 45.647897,
    lng: 8.781334,
  },
];

export const adminEmails = [
  "a.falzetti@onoranzefunebricloud.com",
  "l.cerasoni@onoranzefunebricloud.com",
  "f.salvatore@onoranzefunebricloud.com",
  "m.mercuri@onoranzefunebricloud.com",
  "e.albertazzi@onoranzefunebricloud.com",
  "j.iacoponi@onoranzefunebricloud.com",
  "r.dinoia@onoranzefunebricloud.com",
];

export const staffEmails = [
  ...adminEmails,
  "a.falzetti+monitor_ufficio_1@onoranzefunebricloud.com",
];

// Route access configuration - used by Sidebar to check route permissions
// This is kept for backward compatibility and specific route pattern matching
export const routeAccessConfig = [
  {
    pattern: "^/$",
    allowNonStaff: true,
  },
  {
    pattern: "^/apps$",
    allowNonStaff: true,
  },
  {
    pattern: "^/clients/?.*$",
    allowNonStaff: true,
  },
  {
    pattern: "^/orgs/?.*$",
    allowNonStaff: true,
  },
  {
    pattern: "^/users/?.*$",
    allowNonStaff: true,
  },
  {
    pattern: "^/internal-drive/?.*$",
    allowNonStaff: true,
  },
  {
    pattern: "^/send-notifications$",
    restrictAccessToOfcAdmin: true,
  },
  {
    pattern: "^/db/backup/download$",
    restrictAccessToOfcAdmin: true,
  },
  {
    pattern: "^/db/backup/restore$",
    restrictAccessToOfcAdmin: true,
  },
  {
    pattern: "^/settings/modules$",
    restrictAccessToOfcAdmin: true,
  },
  {
    pattern: "^/settings/icons$",
    restrictAccessToOfcAdmin: true,
  },
  {
    pattern: "^/company-reports$",
    restrictAccessToOfcAdmin: true,
  },
];
